<dx-popup
    #collectionReferralDetail
    width="45%"
    height="60%"
    title="Collections Referral: {{ popupTitle }}"
    [showTitle]="true"
    [dragEnabled]="true"
    [resizeEnabled]="true"
    [closeOnOutsideClick]="false"
    [visible]="visible"
    (onShown)="onPopupShown()"
    (onHidden)="onPopupHidden()"
>
    <div *dxTemplate="let data of 'content'">
        <dx-box width="100%" height="100%" direction="col">
            <dxi-item [ratio]="1">
                <div *dxTemplate>
                    <dx-form width="100%" height="100%" [colCount]="1" labelLocation="top">
                        <dxi-item>
                            <dxo-label text="Collection Item"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area
                                    [minHeight]="90"
                                    [maxHeight]="150"
                                    [readOnly]="true"
                                    [(value)]="collectionsDetail.collectionItem"
                                ></dx-text-area>
                            </div>
                        </dxi-item>
                        <dxi-item>
                            <dxo-label text="Collections Notes"></dxo-label>
                            <div *dxTemplate>
                                <dx-text-area
                                    [minHeight]="90"
                                    [maxHeight]="150"
                                    [readOnly]="true"
                                    [(value)]="collectionsDetail.notes"
                                ></dx-text-area>
                            </div>
                        </dxi-item>
                    </dx-form>
                </div>
            </dxi-item>
            <dxi-item baseSize="auto">
                <div *dxTemplate>
                    <dx-toolbar width="100%">
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-button
                                    type="default"
                                    text="Cancel"
                                    hint="Cancel"
                                    [icon]="iconCancel"
                                    (onClick)="onCancelClick()"
                                ></dx-button>
                            </div>
                        </dxi-item>
                        <dxi-item location="after" [visible]="mode !== 'CLOSED'">
                            <div *dxTemplate>
                                <app-hyperlink-creator
                                    mode="hyperlinkOnly"
                                    displayText="View Transactions"
                                    (onLinkClick)="onViewStatementClick()"
                                ></app-hyperlink-creator>
                            </div>
                        </dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
        </dx-box>
    </div>
</dx-popup>
